module.exports = __webpack_public_path__ + "static/media/AaronGrothe.dc36f479.jpg";